export const CheckFill = ({ className, onClick }: { className?: string; onClick?: () => void }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.00033 0.666992C3.95024 0.666992 0.666992 3.95024 0.666992 8.00033C0.666992 12.0504 3.95024 15.3337 8.00033 15.3337C12.0504 15.3337 15.3337 12.0504 15.3337 8.00033C15.3337 3.95024 12.0504 0.666992 8.00033 0.666992ZM11.1791 6.76046C11.4149 6.47759 11.3767 6.05722 11.0938 5.82151C10.8109 5.5858 10.3905 5.62401 10.1549 5.90687L7.28886 9.34606L5.80507 7.86226C5.54471 7.60193 5.12261 7.60193 4.86225 7.86226C4.60191 8.12259 4.60191 8.54473 4.86225 8.80506L6.86226 10.8051C6.99473 10.9375 7.17673 11.0081 7.36386 10.9997C7.55099 10.9911 7.72593 10.9043 7.84579 10.7605L11.1791 6.76046Z"
        fill="currentColor"
      />
    </svg>
  );
};
